import { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import ActionButtons, { EditButton, DeleteButton } from '../../components/ActionButtons';
import DataTable from '../../components/DataTable';
import ModalShell from '../../components/ModalShell';
import GeriButon from '../../components/GeriButon';
import { apiRequest } from '../../services/api';
import UsageInfo from '../../components/UsageInfo';
import { useKasa } from '../../context/KasaContext';
import EmptyState from '../../components/EmptyState';
import PageHeader from '../../components/PageHeader';

function FormHata({ mesaj }) {
  if (!mesaj) return null;
  return <p className="text-[10px] font-black text-rose-500 uppercase tracking-widest mt-2 flex items-center gap-1 animate-shake">⚠️ {mesaj}</p>;
}

const toTitleCase = (str) => str ? str.toLocaleLowerCase('tr-TR').split(' ').map(word => word.charAt(0).toLocaleUpperCase('tr-TR') + word.slice(1)).join(' ') : '';

function GrupForm({ kayit, liste, onKaydet, onGeri, kaydediliyor, hata }) {
  const yeni = !kayit;
  const [ad, setAd] = useState(kayit?.ad ?? '');
  const [siraNo, setSiraNo] = useState(kayit?.siraNo ?? (liste.length + 1));
  const [aktifMi, setAktifMi] = useState(kayit?.aktifMi !== false);
  const [hatalar, setHatalar] = useState({});

  const INP = (hata) =>
    `w-full border-2 rounded-2xl px-5 py-3.5 text-sm font-bold text-gray-800 transition-[border-color,box-shadow,background-color] duration-200 bg-white focus:outline-none ${hata ? 'border-rose-400 bg-rose-50 focus:border-rose-500 shadow-rose-50 shadow-inner' : 'border-gray-100 focus:border-emerald-400 focus:ring-4 focus:ring-emerald-50 shadow-sm'
    }`;

  async function handleKaydet() {
    if (!ad.trim()) { setHatalar({ ad: 'Grup adı zorunludur.' }); return; }
    onKaydet({ ...(kayit ? { gelirGrubuId: kayit.gelirGrubuId } : {}), ad: ad.trim(), siraNo, aktifMi });
  }

  return (
    <ModalShell
      icon={yeni ? '➕' : '✏️'}
      iconColor="from-emerald-500 to-teal-600"
      title={yeni ? 'Yeni Gelir Grubu' : `"${kayit.ad}" Düzenle`}
      subtitle="Mali analiz ve departman bazlı gelir yönetimi"
      onClose={onGeri}
      size="md"
      footer={
        <>
          <button onClick={onGeri} className="px-8 py-3.5 rounded-2xl border-2 border-gray-100 text-xs font-black text-gray-400 hover:bg-gray-100 transition-all uppercase tracking-widest active:scale-95">İPTAL</button>
          <button onClick={handleKaydet} disabled={kaydediliyor}
            className="px-10 py-3.5 bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 disabled:opacity-60 text-white rounded-2xl text-xs font-black shadow-xl shadow-emerald-200 transition-all hover:-translate-y-1 active:translate-y-0 tracking-widest uppercase">
            {kaydediliyor ? '⌛ KAYDEDİLİYOR...' : '💾 GRUBU KAYDET'}
          </button>
        </>
      }
    >
      <div className="space-y-6">
          {(hata || hatalar.genel) && <div className="bg-rose-50 border-2 border-rose-100 rounded-2xl px-5 py-4 text-xs text-rose-600 font-black uppercase tracking-widest leading-none animate-shake">⚠️ {hata || hatalar.genel}</div>}

          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">Grup Adı *</label>
            <input value={ad} onChange={e => { setAd(toTitleCase(e.target.value)); setHatalar({}); }}
              className={INP(hatalar.ad)} placeholder="Örn: KONAKLAMA, RESTORAN, SPA" autoFocus onKeyDown={e => e.key === 'Enter' && handleKaydet()} />
            <FormHata mesaj={hatalar.ad} />
          </div>

          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">Gösterim Sırası</label>
            <div className="relative w-40 group">
              <input type="number" min="1" value={siraNo} onChange={e => setSiraNo(parseInt(e.target.value) || 1)}
                className={INP(false) + ' text-center pr-12'} />
              <div className="absolute right-2 top-1/2 -translate-y-1/2 flex flex-col gap-0.5">
                <button onClick={() => setSiraNo(s => s + 1)} className="w-8 h-5 bg-gray-50 hover:bg-emerald-50 text-gray-400 hover:text-emerald-500 rounded-md flex items-center justify-center text-[8px] transition-all border border-gray-100 shadow-sm leading-none">▲</button>
                <button onClick={() => setSiraNo(s => Math.max(1, s - 1))} className="w-8 h-5 bg-gray-50 hover:bg-emerald-50 text-gray-400 hover:text-emerald-500 rounded-md flex items-center justify-center text-[8px] transition-all border border-gray-100 shadow-sm leading-none">▼</button>
              </div>
            </div>
            <p className="text-[9px] font-bold text-emerald-600/60 mt-4 uppercase tracking-[0.15em] border-l-4 border-emerald-100 pl-4 bg-emerald-50/30 py-2 rounded-r-xl">BU SIRA RAPORLARDA VE MENÜLERDE ÖNCELİĞİ BELİRLER.</p>
          </div>

          <div className="flex items-center justify-between bg-gray-50/50 p-6 rounded-[2rem] border-2 border-gray-100 border-dashed">
            <div>
              <p className="text-[10px] font-black text-gray-800 uppercase tracking-widest leading-none">Grup Durumu</p>
              <p className="text-[9px] font-bold text-gray-400 uppercase tracking-widest mt-2">{aktifMi ? 'Sistem genelinde aktif' : 'Sistem genelinde pasif'}</p>
            </div>
            <button
              onClick={() => setAktifMi(!aktifMi)}
              className={`w-14 h-8 rounded-full transition-all duration-300 relative ${aktifMi ? 'bg-emerald-500' : 'bg-gray-300'}`}
            >
              <div className={`absolute top-1 w-6 h-6 bg-white rounded-full transition-all duration-300 shadow-sm ${aktifMi ? 'left-7' : 'left-1'}`} />
            </button>
          </div>
      </div>
    </ModalShell>
  );
}

export default function GelirGruplari() {
  const { fetchVeriler: fetchKasa } = useKasa();
  const [liste, setListe] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [hata, setHata] = useState(null);
  const [view, setView] = useState('liste');
  const [secili, setSecili] = useState(null);
  const [silOnay, setSilOnay] = useState(null);
  const [arama, setArama] = useState('');
  const [kaydediliyor, setKaydediliyor] = useState(false);

  const veriYukle = useCallback(async () => {
    setYukleniyor(true); setHata(null);
    try { setListe((await apiRequest('gelirgruplari')) || []); }
    catch { setHata('Veriler yüklenemedi.'); }
    setYukleniyor(false);
  }, []);

  useEffect(() => { veriYukle(); }, [veriYukle]);

  async function kaydet(form) {
    setKaydediliyor(true); setHata(null);
    try {
      if (form.gelirGrubuId) await apiRequest('gelirgruplari', 'PUT', form);
      else await apiRequest('gelirgruplari', 'POST', form);
      await veriYukle();
      fetchKasa();
      setView('liste'); setSecili(null);
    } catch (e) {
      setHata(e?.message || 'Hata oluştu.');
    }
    setKaydediliyor(false);
  }

  async function handleToggleAktif(id, aktifMi) {
    try { await apiRequest(`gelirgruplari/${id}/aktif?aktif=${!aktifMi}`, 'PATCH'); await veriYukle(); fetchKasa(); }
    catch (e) { alert(e?.message || 'Hata oluştu.'); }
  }

  async function handleSil(id) {
    try { await apiRequest(`gelirgruplari/${id}`, 'DELETE'); setListe(p => p.filter(x => x.gelirGrubuId !== id)); setSilOnay(null); fetchKasa(); }
    catch (e) { alert(e?.message || 'Silme işlemi başarısız.'); }
  }

  const filtrelenmis = liste.sort((a, b) => (a.siraNo || 0) - (b.siraNo || 0)).filter(x => x.ad?.toLocaleLowerCase('tr-TR').includes(arama.toLocaleLowerCase('tr-TR')));
  const isOpen = view === 'ekle' || view === 'duzenle';

  return (
    <div className="p-3 md:p-6 space-y-7 min-h-screen bg-gray-50/50 animate-fadeIn" style={{ transform: 'translateZ(0)' }}>
      <PageHeader
        icon="📈"
        iconColor="from-emerald-500 to-teal-700"
        iconShadow="shadow-emerald-200"
        title="Gelir Grupları"
        subtitle="Mali analiz ve departman bazlı gelir yönetimi"
      >
        <button onClick={() => { setSecili(null); setView('ekle'); }}
          className="group flex-shrink-0 flex items-center justify-center gap-3 bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 text-white px-10 py-4 rounded-2xl text-[10px] font-black shadow-2xl shadow-emerald-100 transition-[background-color,transform] duration-300 hover:-translate-y-1 active:translate-y-0 uppercase tracking-widest relative overflow-hidden">
          <span className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300"></span>
          <span className="relative text-xl transition-transform group-hover:rotate-90">＋</span>
          <span className="relative font-black">YENİ GELİR GRUBU EKLE</span>
        </button>
      </PageHeader>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        {[
          { label: 'TOPLAM GRUP', value: liste.length, icon: '📁', color: 'from-gray-700 to-gray-900 shadow-gray-200' },
          { label: 'AKTİF GRUP', value: liste.filter(x => x.aktifMi !== false).length, icon: '✅', color: 'from-emerald-500 to-emerald-700 shadow-emerald-100' },
          { label: 'SONUÇLAR', value: filtrelenmis.length, icon: '🔍', color: 'from-teal-500 to-cyan-700 shadow-teal-100' },
        ].map(k => (
          <div key={k.label} className={`relative overflow-hidden bg-gradient-to-br ${k.color} rounded-[2rem] p-6 text-white shadow-xl hover:shadow-2xl transition-[box-shadow,transform] duration-300 group`}>
            <div className="absolute -right-4 -bottom-4 text-7xl opacity-10 pointer-events-none group-hover:scale-125 transition-transform duration-500">{k.icon}</div>
            <p className="text-[10px] font-black uppercase tracking-widest opacity-70 mb-1 leading-none">{k.label}</p>
            <p className="text-2xl font-black tracking-tight leading-none">{k.value}</p>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-[2.5rem] border border-gray-200 shadow-sm overflow-hidden min-h-[400px]">
        <div className="px-6 md:px-8 py-5 border-b border-gray-100 bg-gray-50/30 flex flex-col md:flex-row items-center gap-6">
          <div className="relative flex-1 w-full">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">🔍</span>
            <input value={arama} onChange={e => setArama(e.target.value)} placeholder="Grup adıyla ara..."
              className="w-full pl-11 pr-4 py-3.5 text-sm border-2 border-gray-100 rounded-2xl focus:border-emerald-400 focus:outline-none bg-white shadow-sm transition-all font-bold" />
          </div>
          <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-auto whitespace-nowrap">Sistemde <b className="text-emerald-600 text-xs">{liste.length}</b> kayıt tanımlı</p>
        </div>

        {/* Mobile View */}
        <div className="md:hidden divide-y divide-gray-100 px-2 leading-none">
          {filtrelenmis.length === 0 ? (
            <EmptyState icon="📈" text="Kayıt Bulunamadı" />
          ) : filtrelenmis.map(item => (
            <div key={item.gelirGrubuId} className={`p-6 flex flex-col gap-5 hover:bg-emerald-50/20 transition-all rounded-[2rem] group ${item.aktifMi === false && 'opacity-60 bg-gray-50'}`}>
              <div className="flex items-center gap-5">
                <div className={`w-14 h-14 rounded-2xl flex-shrink-0 flex items-center justify-center font-black text-lg shadow-xl border-2 border-white ${item.aktifMi !== false ? 'bg-gradient-to-br from-emerald-500 to-teal-700 text-white shadow-emerald-100' : 'bg-gray-100 text-gray-400'}`}>
                  {item.ad?.[0]}
                </div>
                <div className="min-w-0 flex-1">
                  <p className={`font-black text-gray-800 text-base mb-1 tracking-tight uppercase truncate ${item.aktifMi === false && 'line-through text-gray-400'}`}>{item.ad}</p>
                  <p className="text-[10px] font-black text-emerald-500 uppercase tracking-widest truncate flex items-center gap-2">📊 SIRA NO: {item.siraNo || '-'}</p>
                </div>
              </div>
              <div className="flex gap-2">
                <button onClick={() => handleToggleAktif(item.gelirGrubuId, item.aktifMi)} className={`flex-1 py-4 rounded-2xl font-black text-[10px] uppercase tracking-widest border transition-all active:scale-95 ${item.aktifMi !== false ? 'bg-emerald-50 text-emerald-600 border-emerald-100 hover:bg-emerald-500 hover:text-white' : 'bg-gray-50 text-gray-400 border-gray-200'}`}>{item.aktifMi !== false ? '✓ AKTİF' : '✗ PASİF'}</button>
                <EditButton size="lg" onClick={() => { setSecili(item); setView('duzenle'); }} />
                <DeleteButton size="lg" onClick={() => setSilOnay(item.gelirGrubuId)} />
              </div>
            </div>
          ))}
        </div>

        {/* Desktop View */}
        <div className="hidden md:block overflow-x-auto leading-none">
          <DataTable
            anahtarAlan="gelirGrubuId"
            satirlar={filtrelenmis}
            bosIkon="📈"
            bosMetin="Sonuç bulunamadı"
            satirSinifi={item => item.aktifMi === false ? 'bg-gray-50/40 opacity-70' : ''}
            kolonlar={[
              {
                anahtar: 'sira', baslik: 'No', genislik: 'w-20',
                ciz: (item, i) => <span className="font-black text-gray-300 text-xs">{i + 1}</span>,
              },
              {
                anahtar: 'ad', baslik: 'Grup Adı',
                ciz: item => (
                  <div className="flex items-center gap-4 min-w-0">
                    <div className={'w-11 h-11 rounded-2xl flex-shrink-0 flex items-center justify-center font-black shadow-xl ' +
                      (item.aktifMi !== false ? 'bg-gradient-to-br from-emerald-500 to-teal-700 text-white shadow-emerald-100' : 'bg-gray-200 text-gray-400')}>
                      {item.ad?.[0]}
                    </div>
                    <span className={'font-black text-gray-700 tracking-tight uppercase truncate text-lg ' +
                      (item.aktifMi === false ? 'line-through text-gray-400' : '')}>{item.ad}</span>
                  </div>
                ),
              },
              {
                anahtar: 'siraNo', baslik: 'Sıra', hizala: 'orta', genislik: 'w-20',
                ciz: item => <span className="font-black text-gray-400 text-xs">{item.siraNo || '-'}</span>,
              },
              {
                anahtar: 'aktifMi', baslik: 'Durum', hizala: 'orta', genislik: 'w-32',
                ciz: item => (
                  <button onClick={() => handleToggleAktif(item.gelirGrubuId, item.aktifMi)}
                    className={'text-[10px] font-black px-4 py-1.5 rounded-full border tracking-widest transition-all active:scale-95 ' +
                      (item.aktifMi !== false
                        ? 'bg-emerald-50 text-emerald-700 border-emerald-100 hover:bg-emerald-500 hover:text-white'
                        : 'bg-gray-100 text-gray-400 border-gray-200 hover:bg-emerald-50 hover:text-emerald-600')}>
                    {item.aktifMi !== false ? 'AKTİF' : 'PASİF'}
                  </button>
                ),
              },
              {
                anahtar: 'islem', baslik: 'İşlemler', hizala: 'sag',
                ciz: item => (
                  <ActionButtons
                    onEdit={() => { setSecili(item); setView('duzenle'); }}
                    onDelete={() => setSilOnay(item.gelirGrubuId)} />
                ),
              },
            ]}
          />
        </div>
      </div>

      <UsageInfo
        color="emerald"
        description="Gelir Grupları, otelinizin farklı departmanlarından (Oda servisi, Restoran, SPA vb.) gelen tüm gelirlerin finansal raporlarda doğru kategorize edilmesini ve analiz edilmesini sağlar."
        scenarios={[
          { title: "Departman Bazlı Analiz", content: "'Yiyecek-İçecek' grubu altında tüm mutfak ve bar satışlarını birleştirerek tesis bazında toplam gıda karlılığını ölçebilirsiniz." },
          { title: "Mali Raporlama", content: "Gelir vergisi ve KDV sınıflandırması yaparken, gruplandırılmış gelir kalemleri muhasebe entegrasyonuna hazırlık sağlar." },
          { title: "Öncelik Yönetimi", content: "Sıra numarası vererek en çok takip ettiğiniz gelir gruplarının (Örn: Oda Geliri) raporların en üstünde görünmesini sağlayabilirsiniz." }
        ]}
      />

      {isOpen && createPortal(
        <GrupForm
          kayit={secili}
          liste={liste}
          onKaydet={kaydet}
          onGeri={() => { setView('liste'); setSecili(null); }}
          kaydediliyor={kaydediliyor}
          hata={hata}
        />,
        document.body
      )}

      {silOnay && createPortal(
        <div className="fixed inset-0 bg-black/60 z-[100] flex items-center justify-center px-4 backdrop-blur-md animate-fade-in shadow-2xl">
          <div className="bg-white rounded-[2.5rem] shadow-2xl p-10 w-full max-w-sm text-center border border-gray-100">
            <div className="w-24 h-24 bg-rose-50 rounded-[2.5rem] flex items-center justify-center mx-auto mb-6 text-5xl shadow-xl shadow-rose-100/50 animate-bounce-subtle">🗑️</div>
            <h3 className="font-black text-gray-900 text-xl tracking-tight uppercase leading-none">Grubu Sil</h3>
            <p className="text-[11px] font-black text-gray-500 mt-5 mb-10 leading-relaxed uppercase tracking-tight"> <b className="text-gray-900">"{liste.find(x => x.gelirGrubuId === silOnay)?.ad}"</b> gelir grubu kalıcı olarak silinecek. Emin misiniz?</p>
            <div className="flex gap-4">
              <button onClick={() => setSilOnay(null)} className="flex-1 py-4 bg-gray-50 text-gray-600 rounded-2xl text-[10px] font-black hover:bg-gray-100 transition-all uppercase tracking-widest active:scale-95">İPTAL</button>
              <button onClick={() => handleSil(silOnay)} className="flex-1 py-4 bg-gradient-to-r from-rose-500 to-red-600 text-white rounded-2xl text-[10px] font-black shadow-xl shadow-rose-200 transition-all uppercase tracking-widest active:scale-95">EVET, SİL</button>
            </div>
          </div>
        </div>,
        document.body
      )}

      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        .animate-fadeIn { animation: fadeIn 0.4s ease-out forwards; }
        @keyframes scaleIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
        .animate-scale-in { animation: scaleIn 0.3s ease-out forwards; }
        @keyframes shake { 0%, 100% { transform: translateX(0); } 25% { transform: translateX(-5px); } 75% { transform: translateX(5px); } }
        .animate-shake { animation: shake 0.3s ease-in-out infinite; animation-iteration-count: 2; }
        @keyframes bounceSubtle { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
        .animate-bounce-subtle { animation: bounceSubtle 2s infinite; }
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </div>
  );
}